import { render, staticRenderFns } from "./SolanT.vue?vue&type=template&id=91b11762&scoped=true&"
import script from "./SolanT.vue?vue&type=script&lang=ts&"
export * from "./SolanT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanT.vue?vue&type=style&index=0&id=91b11762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b11762",
  null
  
)

export default component.exports